// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Is from "../../helpers/Is.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Icon from "../images-and-icons/Icon.res.js";
import * as View from "../../primitives/View.res.js";
import * as TextStyle from "../typography/TextStyle.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function make(kind, data, message) {
  return {
    kind: kind,
    data: data,
    message: message
  };
}

function BackendFailure$Block(props) {
  let failure = props.failure;
  return JsxRuntime.jsx("section", {
    children: JsxRuntime.jsxs(TextStyle.make, {
      children: [
        failure.kind,
        " — ",
        failure.message
      ],
      size: "xxsmall"
    })
  });
}

let Block = {
  make: BackendFailure$Block
};

function BackendFailure$List(props) {
  let backendFailure = props.backendFailure;
  let data = props.data;
  if (Is.empty(data)) {
    return JsxRuntime.jsx("section", {
      children: View.t("Unable to load data"),
      style: {
        color: "#767589",
        fontSize: "12px"
      }
    });
  } else {
    return JsxRuntime.jsxs("details", {
      children: [
        JsxRuntime.jsxs("summary", {
          children: [
            View.t("Unable to load data"),
            " — ",
            View.t("Click to display more details")
          ],
          style: {
            color: "#767589",
            cursor: "pointer",
            fontSize: "12px"
          }
        }),
        View.mapWithIndexKey(data, (failure, key) => JsxRuntime.jsx(BackendFailure$Block, {
          failure: backendFailure(failure)
        }, key))
      ]
    });
  }
}

let List = {
  make: BackendFailure$List
};

function BackendFailure$Icon(props) {
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(Icon.make, {
      name: Icon.typeFromNext("StatusWarning"),
      fill: "#7C2112",
      width: 18,
      height: 18
    }),
    style: {
      cursor: "help",
      marginLeft: "16px"
    },
    title: I18n.t("Unable to load data")
  });
}

let Icon$1 = {
  make: BackendFailure$Icon
};

export {
  make,
  Block,
  List,
  Icon$1 as Icon,
}
/* I18n Not a pure module */
